//window.$ = window.jQuery = require('jquery');

// import $ from 'jquery';
// window.$ = $;
// window.jQuery = $;

import select2 from 'select2';
import select2D from 'select2/dist/js/i18n/de';
import select2Css from 'select2/dist/css/select2.min.css';


import accordion from './accordion';
import step1 from './step1';
import step3 from './step3';
import step4 from './step4';

document.addEventListener('DOMContentLoaded', event => {
  accordion();
  step1();
  step3();
  step4();
});